import {observer} from "mobx-react";
import {Linq, PageContentTitle, Pager, ScrollTable, Searchbar} from "../../ui";
import {fmsPackageOverviewStore} from "../../../store";
import {displayShipmentPackageStatus, displayShipmentProcessType, displayShipmentType} from "../../../api";
import {useNavigate} from "react-router";
import {ShipmentPackageStatusDto} from "../../../api/fms";
import {dateFormat} from "../../../utils";
import {FmsShipmentPackageFilterbar} from "./FmsShipmentPackageFilterbar";
import {formatAddressLine} from "./FmsUtil";

interface StatusCarrier {
    text: string
    cls: string
}
function getStatus(statusDto:ShipmentPackageStatusDto): StatusCarrier {
    switch(statusDto) {
        case ShipmentPackageStatusDto.CLOSING: return {
            text: displayShipmentPackageStatus(statusDto),
            cls: 'has-text-grey-light'
        }
        case ShipmentPackageStatusDto.CLOSED : return {
            text: displayShipmentPackageStatus(statusDto),
            cls: 'has-text-grey-light'
        }
        case ShipmentPackageStatusDto.ACTIVE : return {
            text: displayShipmentPackageStatus(statusDto),
            cls: 'has-text-primary'
        }
    }
}

function distinctVins(vins: string[]): string {
    return Array.from(new Set<string>(vins)).join(",");
}


const FmsShipmentPackageItemList = observer(function FmsShipmentPackageItemList() {
    const navigate = useNavigate()
    return <>
        <PageContentTitle
            actionItem={<FmsShipmentPackageFilterbar />}
        >
            <Searchbar placeholder={"FIN oder Versandaddresse"}/>
        </PageContentTitle>
        <ScrollTable>
            <thead>
            <tr>
                <th>Kunde</th>
                <th>Datum</th>
                <th>FINs</th>
                <th>Versandadresse</th>
                <th>Versandart</th>
                <th>Prozess</th>
                <th style={{width: '10em', paddingRight: '2em'}}>Fach</th>
                <th style={{width: '4.5em'}}>Status</th>
                <th> {/*Status Text*/} </th>
            </tr>
            </thead>
            <tbody>
            {fmsPackageOverviewStore.items.map((val, index) => {
                const target = `/fms/packages/${val.id}`
                const status = getStatus(val.status)

                return <tr
                    key={val.id}
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                        navigate(target)
                    }}
                >
                    <td><Linq to={target}>{val.customerDisplay}</Linq></td>
                    <td><Linq to={target}>{dateFormat(val.audit.createdDate)}</Linq></td>
                    <td title={distinctVins(val.vins)}><Linq to={target}>{distinctVins(val.vins)}</Linq></td>
                    <td title={formatAddressLine(val.receiver)}><Linq to={target}>{formatAddressLine(val.receiver)}</Linq></td>
                    <td><Linq to={target}>{displayShipmentType(val.shipmentType)}</Linq></td>
                    <td><Linq to={target}>{displayShipmentProcessType(val.process)}</Linq></td>
                    <td><Linq to={target}>{val.compartment || ''}</Linq></td>
                    <td style={{paddingRight: '2em'}}>
                        <Linq to={target}>
                            <span className={`material-symbols-outlined ${status.cls}`} title={status.text} style={{flexShrink: 0}}> radio_button_checked</span>
                        </Linq>
                    </td>
                    <td><Linq to={target}>{status.text}</Linq></td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
        <Pager total={fmsPackageOverviewStore.pages}/>
    </>
})

export {
    FmsShipmentPackageItemList
}
